import request from '@/config/axios'

/** 商城游戏抽奖一期只开放这三种，与后端 LOTTERY_STYLES 一致 */
export const MALL_LOTTERY_STYLES = ['wheel', 'grid', 'scratch'] as const

export function isMallLotteryStyle(style?: string) {
  return !!style && (MALL_LOTTERY_STYLES as readonly string[]).includes(style)
}

/**
 * 活动模板（活动市场）
 *
 * `getTemplateMetaList` 是「代码已实现 / DB 未登记」对账用的关键接口：
 * 插件注册表里有、但 `promotion_activity_template` 里没有的玩法，会以 `registered=false` 返回，
 * 页面据此给出告警并提供 `syncFromPlugins` 一键补登记。
 * 2026-09-16 营销中心合并开发 P4
 */

/** 活动模板 VO（对应后端 ActivityTemplateRespVO） */
export interface ActivityTemplateVO {
  id?: number
  categoryId?: number
  /** 玩法编码（与 Java 插件一一对应） */
  style?: string
  name?: string
  subTitle?: string
  coverUrl?: string
  previewUrl?: string
  description?: string
  /** 标签（逗号分隔） */
  tags?: string
  /** 配置项 Schema（管理端表单渲染依据） */
  configSchema?: Record<string, any>
  defaultConfig?: Record<string, any>
  /** 使用热度 */
  orderCount?: number
  sort?: number
  /** 状态：0-上架 1-下架 */
  status?: number
  remark?: string
  createTime?: string
}

/** 模板分类 VO */
export interface ActivityTemplateCategoryVO {
  id?: number
  name?: string
  code?: string
  icon?: string
  sort?: number
  status?: number
}

/** 玩法元数据对账项 VO */
export interface ActivityTemplateMetaVO {
  style?: string
  name?: string
  category?: number
  categoryName?: string
  /** 数据库是否已登记（false = 代码有但 DB 没有，需 sync） */
  registered?: boolean
  templateId?: number
  templateStatus?: number
  configSchema?: Record<string, any>
}

/** 获得活动模板分页 */
export function getTemplatePage(params: any) {
  return request.get({ url: '/promotion/activity-template/page', params })
}

/** 按分类获得模板列表（活动市场网格视图） */
export function getTemplateListByCategory(categoryId?: number) {
  return request.get({ url: '/promotion/activity-template/list-by-category', params: { categoryId } })
}

/** 获得模板分类列表 */
export function getTemplateCategoryList() {
  return request.get({ url: '/promotion/activity-template/category-list' })
}

/** 获得玩法元数据（代码已实现 vs DB 已登记 对账） */
export function getTemplateMetaList() {
  return request.get({ url: '/promotion/activity-template/list-meta' })
}

/** 创建活动模板 */
export function createTemplate(data: ActivityTemplateVO) {
  return request.post({ url: '/promotion/activity-template/create', data })
}

/** 更新活动模板 */
export function updateTemplate(data: ActivityTemplateVO) {
  return request.put({ url: '/promotion/activity-template/update', data })
}

/** 更新模板上下架状态 */
export function updateTemplateStatus(id: number, status: number) {
  return request.put({ url: '/promotion/activity-template/update-status', data: { id, status } })
}

/** 删除活动模板 */
export function deleteTemplate(id: number) {
  return request.delete({ url: '/promotion/activity-template/delete', params: { id } })
}

/** 按插件元数据批量补登记（返回补登记条数） */
export function syncFromPlugins() {
  return request.post({ url: '/promotion/activity-template/sync' })
}
